<template>
    <div class="row">
        <div class="col" :class="[grid.colTwo.cols, grid.colOne.greyBackground ? 'light-grey-background' : '']">
            <slot name="left-column"></slot>
        </div>
        <div class="col" :class="[grid.colTwo.cols, grid.colTwo.greyBackground ? 'light-grey-background' : '']">
            <slot name="right-column"></slot>
        </div>
    </div>
</template>
<script>
export default {
  props: ['greyBackground', 'grid'],
}
</script>